import React, { useState, useContext, useEffect } from "react";
import "./invoice.css";
import MyContext from "./Context";

const Invoice = () => {
  const {
    companyName,
    setCompanyName,
    name,
    setName,
    gstin,
    setGstin,
    address,
    setAddress,
    address2,
    setAddress2,
    city,
    setCity,
    state,
    setState,
    country,
    setCountry,
    invoiceNumber,
    setInvoiceNumber,
    invoiceDate,
    setInvoiceDate,
    clientCompany,
    setClientCompany,
    clientGstin,
    setClientGstin,
    clientAddress,
    setClientAddress,
    clientAddress2,
    setClientAddress2,
    clientCity,
    setClientCity,
    clientState,
    setClientState,
    clientCountry,
    setClientCountry,
    shipToCompany,
    setShipToCompany,
    shipToGstin,
    setShipToGstin,
    shipToAddress,
    setShipToAddress,
    shipToAddress2,
    setShipToAddress2,
    shipToCity,
    setShipToCity,
    shipToState,
    setShipToState,
    shipToCountry,
    setShipToCountry,
    tableData,
    setTableData,
    imageUrl,
    setImageUrl,
    subTotal,
    setSubTotal,
    cgst,
    setCgst,
    sgst,
    setSgst,
    total,
    setTotal,
    notes,
    setNotes,
    terms,
    setTerms,
    showPreview,
    setShowPreview,
    gst,
    setGst,
    toggleSwitch,
    setToggleSwitch,
  } = useContext(MyContext);

  const [rows, setRows] = useState([
    { description: "", qty: 0, rate: 0, hsn: "", amount: 0 },
  ]);

  useEffect(() => {
    setTableData(rows);
  }, [rows, setTableData]);

  const fileChosen = (event) => {
    if (!event.target.files.length) return;
    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => setImageUrl(e.target.result);
  };

  const handleDelete = () => {
    setImageUrl(null);
    document.getElementById("logo").value = null;
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      { description: "", qty: 0, rate: 0, hsn: "", amount: 0 },
    ]);
  };

  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    updatedRows[index].amount =
      updatedRows[index].qty * updatedRows[index].rate;
    setRows(updatedRows);
  };

  useEffect(() => {
    const subtotal = rows.reduce((acc, row) => acc + row.amount, 0);
    setSubTotal(subtotal);
    const GST = parseInt(cgst) + parseInt(sgst);
    setGst(GST);

    const totalAmount =
      subtotal + subtotal * (cgst / 100) + subtotal * (sgst / 100);
    setTotal(totalAmount);
  }, [rows, cgst, sgst]);

  const onSubmit = (e) => {
    e.preventDefault();
    console.log("Company Name:", companyName);
    console.log("Invoice Date:", invoiceDate);
    console.log("Client Company:", clientCompany);
    console.log("Table Data:", rows);
  };

  return (
    <>
      <form onSubmit={onSubmit} style={{ marginTop: "30px" }}>
        <div className="container">
          <div className="invoice-container">
            <div className="header">
              <div>
                <label htmlFor="logo">
                  <div className="w-full h-48 rounded bg-gray-100 border border-gray-200 flex items-center justify-center overflow-hidden">
                    {imageUrl ? (
                      <div style={{ position: "relative" }}>
                        <img
                          src={imageUrl}
                          alt="Preview"
                          className="object-cover"
                          style={{ width: "100px", height: "100px" }}
                        />
                        <button
                          onClick={handleDelete}
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "20",
                            backgroundColor: "black",
                            color: "white",
                            border: "none",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    ) : (
                      <div
                        className="text-gray-300 flex flex-col items-center"
                        style={{ height: "130px", width: "100px" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-8 w-8"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                          />
                        </svg>
                        <div>Upload Image</div>
                      </div>
                    )}
                  </div>
                </label>
                <input
                  className="w-full cursor-pointer"
                  type="file"
                  name="logo"
                  id="logo"
                  onChange={fileChosen}
                />
              </div>
              <h1>INVOICE GENERATOR</h1>
            </div>

            {/* Company Details */}
            <div className="company-info">
              <input
                type="text"
                name="companyName"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                placeholder="Your Company"
                required
              />
              {/* <input
                type="text"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your Name"
              /> */}
              <input
                type="text"
                name="gstin"
                value={gstin}
                onChange={(e) => setGstin(e.target.value)}
                placeholder="Company's GSTIN"
              />
              <input
                type="text"
                name="address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Company's Address line 1"
              />
              <input
                type="text"
                name="address2"
                value={address2}
                onChange={(e) => setAddress2(e.target.value)}
                placeholder="Company's Address line 2"
              />
              <input
                type="text"
                name="city"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                placeholder="City"
              />
              <input
                type="text"
                name="state"
                value={state}
                onChange={(e) => setState(e.target.value)}
                placeholder="State"
              />
              <input
                type="text"
                name="country"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                placeholder="India"
              />
            </div>

            {/* Client Details */}
            <section style={{ display: "flex", marginTop: "50px" }}>
              <div
                className="client-info"
                style={{ width: "auto", marginRight: "30px" }}
              >
                <h3>Bill To:</h3>
                <input
                  type="text"
                  name="clientCompany"
                  value={clientCompany}
                  onChange={(e) => setClientCompany(e.target.value)}
                  placeholder="Client's Company"
                  required
                />
                <input
                  type="text"
                  name="clientGstin"
                  value={clientGstin}
                  onChange={(e) => setClientGstin(e.target.value)}
                  placeholder="Client's GSTIN"
                />
                <input
                  type="text"
                  name="clientAddress"
                  value={clientAddress}
                  onChange={(e) => setClientAddress(e.target.value)}
                  placeholder="Client's Address line 1"
                />
                <input
                  type="text"
                  name="clientAddress2"
                  value={clientAddress2}
                  onChange={(e) => setClientAddress2(e.target.value)}
                  placeholder="Client's Address line 2"
                />
                <input
                  type="text"
                  name="clientCity"
                  value={clientCity}
                  onChange={(e) => setClientCity(e.target.value)}
                  placeholder="City"
                />
                <input
                  type="text"
                  name="clientState"
                  value={clientState}
                  onChange={(e) => setClientState(e.target.value)}
                  placeholder="State"
                />
                <input
                  type="text"
                  name="clientCountry"
                  value={clientCountry}
                  onChange={(e) => setClientCountry(e.target.value)}
                  placeholder="India"
                />
              </div>

              {/* Invoice Details */}
              <div
                className="invoice-info"
                style={{ width: "100%", marginRight: "80px" }}
              >
                <div>
                  <label>Invoice#</label>
                  <input
                    type="text"
                    name="invoiceNumber"
                    value={invoiceNumber}
                    onChange={(e) => setInvoiceNumber(e.target.value)}
                    placeholder="INV-01"
                  />
                </div>
                <div>
                  <label>Invoice Date</label>
                  <input
                    type="date"
                    name="invoiceDate"
                    value={invoiceDate}
                    onChange={(e) => setInvoiceDate(e.target.value)}
                  />
                </div>
              </div>
            </section>
            <div style={{ marginTop: "15px" }}>
              <label class="switch">
                <input
                  type="checkbox"
                  checked={toggleSwitch}
                  onClick={() => setToggleSwitch(!toggleSwitch)}
                />
                {toggleSwitch ? "Disable Ship To" : "Enable Ship To"}
                <span class="slider"></span>
              </label>
            </div>
            {toggleSwitch && (
              <div
                className="client-info"
                style={{ width: "48%", marginTop: "25px" }}
              >
                <h3 style={{ marginBottom: "10px" }}>Ship To:</h3>
                <input
                  type="text"
                  name="shipToCompany"
                  value={shipToCompany}
                  onChange={(e) => setShipToCompany(e.target.value)}
                  placeholder="Shipping Company"
                  required
                />
                <input
                  type="text"
                  name="shipToGstin"
                  value={shipToGstin}
                  onChange={(e) => setShipToGstin(e.target.value)}
                  placeholder="Shipping GSTIN"
                />
                <input
                  type="text"
                  name="shipToAddress"
                  value={shipToAddress}
                  onChange={(e) => setShipToAddress(e.target.value)}
                  placeholder="Shipping Address line 1"
                />
                <input
                  type="text"
                  name="shipToAddress2"
                  value={shipToAddress2}
                  onChange={(e) => setShipToAddress2(e.target.value)}
                  placeholder="Shipping Address line 2"
                />
                <input
                  type="text"
                  name="shipToCity"
                  value={shipToCity}
                  onChange={(e) => setShipToCity(e.target.value)}
                  placeholder="City"
                />
                <input
                  type="text"
                  name="shipToState"
                  value={shipToState}
                  onChange={(e) => setShipToState(e.target.value)}
                  placeholder="State"
                />
                <input
                  type="text"
                  name="shipToCountry"
                  value={shipToCountry}
                  onChange={(e) => setShipToCountry(e.target.value)}
                  placeholder="India"
                />
              </div>
            )}

            {/* Invoice Table */}
            <section style={{ marginTop: "50px" }}>
              <table>
                <thead>
                  <tr>
                    <th>Description</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>HSN Code</th>
                    <th>Amount</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          value={row.description}
                          onChange={(e) =>
                            handleChange(index, "description", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={row.qty}
                          onChange={(e) =>
                            handleChange(index, "qty", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={row.rate}
                          onChange={(e) =>
                            handleChange(index, "rate", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.hsn}
                          onChange={(e) =>
                            handleChange(index, "hsn", e.target.value)
                          }
                        />
                      </td>
                      <td>{row.amount.toFixed(2)}</td>
                      <td>
                        <button onClick={() => handleDeleteRow(index)}>
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <button type="button" onClick={handleAddRow}>
                Add Line
              </button>

              {/* Totals */}
              <table
                style={{
                  marginTop: "15px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <tfoot>
                  <tr>
                    <td colSpan="5">Sub Total</td>
                    <td>₹{subTotal.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td
                      colSpan="5"
                      // style={{
                      //   display: "flex",
                      //   justifyContent: "center",
                      //   alignItems: "center",
                      // }}
                    >
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        SGST
                        <div
                          className="cgst-div"
                          style={{
                            width: "50px",
                            marginLeft: "10px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="number"
                            style={{ fontSize: "medium" }}
                            maxLength={2}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                            }}
                            onChange={(e) => setSgst(e.target.value)}
                            min="0"
                            max="99"
                          />
                          <span style={{ paddingLeft: "5px" }}>%</span>
                        </div>
                      </span>
                    </td>
                    <td>{(subTotal * (sgst / 100)).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td colSpan="5">
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        CGST
                        <div
                          className="cgst-div"
                          style={{
                            width: "50px",
                            marginLeft: "10px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="number"
                            style={{ fontSize: "medium" }}
                            maxLength={2}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                            }}
                            onChange={(e) => setCgst(e.target.value)}
                            min="0"
                            max="99"
                          />
                          <span style={{ paddingLeft: "5px" }}>%</span>
                        </div>
                      </span>
                    </td>
                    <td>{(subTotal * (cgst / 100)).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td colSpan="5">
                      <strong>
                        GST{" "}
                        {parseInt(sgst) + parseInt(cgst)
                          ? parseInt(sgst) + parseInt(cgst)
                          : 0}
                        %
                      </strong>
                    </td>
                    <td>
                      <strong>
                        ₹
                        {(
                          subTotal * (cgst / 100) +
                          subTotal * (sgst / 100)
                        ).toFixed(2)}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="5">
                      <strong>Total</strong>
                    </td>
                    <td>
                      <strong>₹{total.toFixed(2)}</strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
              <div className="notes-terms">
                <div className="left-side">
                  <h4>Notes</h4>
                  <textarea
                    style={{
                      width: "1000px !important",
                      height: "auto",
                    }}
                    value={notes} // Controlled component
                    onChange={(e) => setNotes(e.target.value)}
                    rows="3"
                    placeholder="Enter notes here..."
                  />
                  <h4>Terms and Conditions</h4>
                  <textarea
                    value={terms} // Controlled component
                    onChange={(e) => setTerms(e.target.value)}
                    rows="3"
                    placeholder="Enter terms and conditions here..."
                  />
                </div>
                <div className="right-side">
                  <p>Powered By PearlaX</p>
                  <img
                    src="/images/companylogo.png"
                    alt="Company Logo"
                    className="company-logo"
                  />
                </div>
              </div>
            </section>
          </div>
        </div>
      </form>
    </>
  );
};

export default Invoice;
